import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20gradient%20background%20in%20soft%20amber%20and%20cream%20tones%2C%20flowing%20smooth%20texture%2C%20elegant%20minimalist%20composition%2C%20gentle%20light%20diffusion%2C%20warm%20golden%20atmosphere%2C%20subtle%20paper%20grain%20texture%2C%20no%20text%20or%20letters%2C%20pure%20visual%20texture%20for%20overlay&width=1600&height=600&seq=cta-po-lit-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好了吗？开始你的po文创作之旅
        </h2>
        <p className="text-background-300 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          无论你是零基础的新手，还是想要突破瓶颈的进阶创作者，这里都有你需要的全部资源。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rumen"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            从入门开始
            <i className="ri-rocket-line ml-2"></i>
          </Link>
          <Link
            to="/category/jiqiao"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-background-50/15 text-background-50 backdrop-blur-sm font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            进阶技巧
            <i className="ri-arrow-right-up-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}